import { ReactNode } from 'react';
import {
  Answer,
  ButtonAdd,
  ButtonContainer,
  ButtonSubtract,
  Question as QuestionContainer,
} from './Accordion.styles';

interface Props {
  answer: ReactNode;
  index: number;
  isOpen: boolean;
  onClick: () => void;
  question: string;
  setShowingIndex: (index: number | null) => void;
}

export const Question = ({
  answer,
  index,
  isOpen,
  onClick,
  question,
  setShowingIndex,
  ...restProps
}: Props) => (
  <>
    <QuestionContainer onClick={onClick} {...restProps}>
      {question}{' '}
      <ButtonContainer>
        {!isOpen && <ButtonAdd onClick={() => setShowingIndex(index)} />}
        {isOpen && <ButtonSubtract onClick={() => setShowingIndex(null)} />}
      </ButtonContainer>
    </QuestionContainer>
    {isOpen && <Answer>{answer}</Answer>}
  </>
);
